import { css } from 'styled-components';

export const dragAndDropStyles = () => css`
  .drag-and-drop-partner-document div div label > div {
    min-height: 226px;
    display: grid;
    align-content: center;
    justify-items: center;
  }
`;
